import React, { useState } from 'react';
import noImage from '../Assets/images/broken-placeholder-image.png'
import loadingImage from '../Assets/images/picture-loading.gif'

const Image = ({ src, defaultImage = noImage, alt = "", height = "5px", width = "5px", objectFit = "cover", className = "" }) => {
  const [loading, setLoading] = useState(src ? true : false);
  return (
    <React.Fragment>
      {loading && ( <img src={loadingImage} className={className} alt="Loading" style={{ width: width, height: height, objectFit: objectFit, border:"0px" }} /> )}
      <img style={{ display: src ? loading ? 'none' : '' : '', width: width, height: height, objectFit: objectFit }} src={src ? src : defaultImage} alt={alt} className={className} onLoad={()=>{ setLoading(false) }} onError={(e) => { e.target.onerror = null; e.target.src=defaultImage }}/>
    </React.Fragment>
  );
};
export default Image;